class VueAppSubFolder {
	get() {
		if (process.env.VUE_APP_SUBFOLDER) {
			global.VUE_APP_SUBFOLDER = process.env.VUE_APP_SUBFOLDER;
		}
		return global.VUE_APP_SUBFOLDER;
	}
}
const vueAppSubfolder = new VueAppSubFolder();
export default vueAppSubfolder;
